import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

/**
 * Reports whether the signed-in operator may administer users (issue #379).
 *
 * Reads the roles GET /me returns (#377). It previously probed the admin
 * listing with a one-row page and read a 403 as "not an admin" — there was no
 * endpoint that would say. That worked, but it meant every load sent a request
 * expected to fail, and an offline or expired session was indistinguishable
 * from a lack of permission.
 *
 * Gates *visibility* only. Every admin route is enforced server-side regardless
 * of what the UI renders, so a stale or tampered role here changes what is
 * displayed and nothing about what is allowed.
 */
export const useAdminAccess = (): boolean =>
  useSelector((state: RootState) => state.user.roles.includes('admin'));
